import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export default class MaintenanceRouteResolver {
  static readonly maintenanceUrl = '/maintenance';
}
